import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["aria-owns"]
const _hoisted_4 = ["draggable", "onClick", "onDragstart", "onDragend"]
const _hoisted_5 = ["id", "aria-selected", "aria-label", "aria-controls", "onKeyup"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "tab-label" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["alt"]

import { RIGHT, LEFT } from '@shell/utils/position';
import { PropType } from 'vue';
import { RcButton } from '@components/RcButton';
import { RcIcon } from '@components/RcIcon';
import { Position, Tab } from '@shell/types/window-manager';
import TabBodyContainer from './TabBodyContainer.vue';
import { tabBodyId, tabId } from './tab-body';
import usePanelHandler from '../composables/usePanelHandler';


export default /*@__PURE__*/_defineComponent({
  __name: 'VerticalPanel',
  props: {
  position: {
    type:    String as PropType<Position>,
    default: RIGHT,
  },
},
  setup(__props) {

const props = __props;

const {
  tabs,
  activeTab,
  isTabsHeaderEnabled,
  dragOverPositionsActive,
  dragOverTabBarActive,
  setTabActive,
  onTabReady,
  onTabClose,
  mouseResizeXStart,
  keyboardResizeX,
  lockedPosition,
  onTabBarDragOver,
  onTabBarDragLeave,
  onTabBarDrop,
  onDragPositionStart,
  onDragPositionEnd,
} = usePanelHandler({ position: props.position });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "vertical-window-manager",
    "data-testid": "vertical-window-manager",
    class: _normalizeClass(["vertical-window-manager", {
      'wm-vr': props.position === _unref(RIGHT),
      'wm-vl': props.position === _unref(LEFT),
      'drag-start': _unref(dragOverPositionsActive),
      'drag-end': !_unref(dragOverPositionsActive),
      'tabs-header-enabled': _unref(isTabsHeaderEnabled),
    }])
  }, [
    (_unref(isTabsHeaderEnabled))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'tabs',
        {
          'tab-bar-highlight': _unref(dragOverTabBarActive),
          'resizer-left': props.position === _unref(LEFT),
        }
      ]),
          onDragover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(onTabBarDragOver) && _unref(onTabBarDragOver)(...args))),
          onDragleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(onTabBarDragLeave) && _unref(onTabBarDragLeave)(...args))),
          onDrop: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(onTabBarDrop) && _unref(onTabBarDrop)(...args)))
        }, [
          (props.position === _unref(RIGHT))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "resizer resizer-x",
                role: "button",
                tabindex: "0",
                "aria-label": _ctx.t('wm.resize', {arrow1: 'left', arrow2: 'right'}),
                "aria-expanded": "true",
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(mouseResizeXStart)($event)), ["prevent","stop"])),
                onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(mouseResizeXStart)($event)), ["prevent","stop"])),
                onKeyup: [
                  _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeX)(true)), ["prevent","stop"]), ["left"])),
                  _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeX)(false)), ["prevent","stop"]), ["right"]))
                ]
              }, [
                _createElementVNode("i", {
                  class: "icon icon-code",
                  alt: _ctx.t('wm.resize', {arrow1: 'left', arrow2: 'right'})
                }, null, 8, _hoisted_2)
              ], 40, _hoisted_1))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createTextVNode()),
          _createElementVNode("div", {
            role: "tablist",
            "aria-owns": _unref(tabs).map((tab) => _unref(tabId)(props.position, tab.id)).join(' ')
          }, null, 8, _hoisted_3),
          _cache[14] || (_cache[14] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["tab", {
          'active': tab.id === _unref(activeTab)[props.position],
          'draggable': !_unref(lockedPosition),
        }]),
              draggable: tab.id === _unref(activeTab)[props.position] && !_unref(lockedPosition),
              onClick: ($event: any) => (_unref(setTabActive)({ position: props.position, id: tab.id })),
              onDragstart: ($event: any) => (_unref(onDragPositionStart)({ event: $event, tab })),
              onDragend: ($event: any) => (_unref(onDragPositionEnd)({ event: $event, tab }))
            }, [
              _createElementVNode("div", {
                id: _unref(tabId)(props.position, tab.id),
                class: "tab-title",
                role: "tab",
                "aria-selected": tab.id === _unref(activeTab)[props.position],
                "aria-label": tab.label,
                "aria-controls": _unref(tabBodyId)(props.position, tab.id),
                tabindex: "0",
                onKeyup: _withKeys(($event: any) => (_unref(setTabActive)({ position: props.position, id: tab.id })), ["enter","space"])
              }, [
                (tab.icon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["icon", {
              ['icon-'+ tab.icon]: true,
            }]),
                      alt: _ctx.t('wm.tabIcon')
                    }, null, 10, _hoisted_6))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("span", _hoisted_7, _toDisplayString(tab.label), 1)
              ], 40, _hoisted_5),
              _cache[12] || (_cache[12] = _createTextVNode()),
              _createVNode(_unref(RcButton), {
                "data-testid": "wm-tab-close-button",
                variant: "ghost",
                size: "small",
                class: "closer wm-closer-button",
                tabindex: "0",
                "aria-label": _ctx.t('wm.closeTab', { tabId: tab.id }),
                onClick: _withModifiers(($event: any) => (_unref(onTabClose)(tab.id)), ["stop"]),
                onKeyup: _withKeys(_withModifiers(($event: any) => (_unref(onTabClose)(tab.id)), ["stop"]), ["enter","space"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RcIcon), {
                    type: "close",
                    size: "inherit"
                  })
                ]),
                _: 1
              }, 8, ["aria-label", "onClick", "onKeyup"])
            ], 42, _hoisted_4))
          }), 128)),
          _cache[15] || (_cache[15] = _createTextVNode()),
          (props.position === _unref(LEFT))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "resizer resizer-x resizer-align-right",
                role: "button",
                tabindex: "0",
                "aria-label": _ctx.t('wm.resize', {arrow1: 'left', arrow2: 'right'}),
                "aria-expanded": "true",
                onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(mouseResizeXStart)($event)), ["prevent","stop"])),
                onTouchstart: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(mouseResizeXStart)($event)), ["prevent","stop"])),
                onKeyup: [
                  _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeX)(true)), ["prevent","stop"]), ["left"])),
                  _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_unref(keyboardResizeX)(false)), ["prevent","stop"]), ["right"]))
                ]
              }, [
                _createElementVNode("i", {
                  class: "icon icon-code",
                  alt: _ctx.t('wm.resize', {arrow1: 'left', arrow2: 'right'})
                }, null, 8, _hoisted_9)
              ], 40, _hoisted_8))
            : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true),
    _cache[16] || (_cache[16] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
      return _withDirectives((_openBlock(), _createBlock(TabBodyContainer, {
        id: tab.id,
        key: `${ props.position }-${ tab.id }`,
        position: props.position,
        onReady: ($event: any) => (_unref(onTabReady)({ tab, containerId: $event }))
      }, null, 8, ["id", "position", "onReady"])), [
        [_vShow, tab.id === _unref(activeTab)[props.position]]
      ])
    }), 128))
  ], 2))
}
}

})